define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/reflection",
	"csi/xml"
], function(declare, _, reflection, xml) {

	return declare(null, {

		// additional source or destination attributes that need to be mapped in addition to custom attributes
		sourceAttributeNames: [],
		destinationAttributeNames: [],

		_getSourceAttributes: function() {
			// summary: return the map's "from" attributes
			// define in overriding class variable sourceClassName
			var classes = [this.sourceClassName];
			if (this.additionalSourceClassNames)
				classes = classes.concat(this.additionalSourceClassNames);
			return this._sortById(this._getMappingAttributes(this.sourceClassName, this.sourceAttributeNames).concat(this._getCustomAttributes(classes)));
		},

		_getDestAttributes: function() {
			// summary: return the map's "to" attributes, in display order
			// define in overriding class variable destinationClassNames
			return this._sortById(this._getMappingAttributes(this.destinationClassNames, this.destinationAttributeNames).concat(this._getCustomAttributes(this.destinationClassNames)));
		},

		_getCustomAttributes: function(classNameOrNames) {
			// summary: return an array of custom attributes (and relations), unsorted
			return _.reduce(classNameOrNames, function(attrs, className) {
				return attrs.concat(this._getCustomAttributesInner(className));
			}, [], this);
		},

		_getCustomAttributesInner: function(className) {
			// summary: return an array of custom attributes (and relations), unsorted
			var rc = reflection.getClass(className);
			return rc ? _.filter(rc.getAttributes(true), function(attr) {return attr.isCustom;}) : [];
		},

		_getMappingAttributes: function(className, attributeNames) {
			// className : string - className or array -  array of classNames
			// check the className - if not array, convert to array
			var classNames = !Array.isArray(className) ? [className] : className;
			return classNames.flatMap((className) => {
				const rc = reflection.getClass(className);
				return attributeNames.map((attrName) =>  rc.getAttribute(attrName, true, true, true));
			});
		},

		_sortById: function(attrs) {
			return _.sortBy(attrs, function(attr) {return attr.getId();});
		},

		_getTypeForMatching: function(attr) {
			// summary: return the type to be used for matching destination attrs against source attrs
			var type = attr.getType();
			if (type === xml.ATTR_ENUM) {
				type += ":" + attr.getValue();
			} else if (type.indexOf(xml.ATTR_REF) == 0) {
				var destinationClass = attr.getDestinationClass();
				var subtype = attr.getSubtypeName();

				if (destinationClass) {
					type += ":" + destinationClass.getType();
				}

				if (subtype) {
					type += ":" + subtype;
				}
			}
			return type;
		}
	});
});
